import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import IntroPage from './components/front_page';
import NavigationBar from './components/navbar';
import { Route,Routes } from 'react-router-dom';
//import AboutUs from './components/about';
import ContactUs from './components/contact';
import CoreValue from './components/CoreV';
import Overview from './components/overview';
import Team from './components/team';
import Products from './components/products';


const WHATSAPP_NUMBER = '919278077911';
const WHATSAPP_MESSAGE = encodeURIComponent('Hello, I would like to enquire about your pharmaceutical products.');

function App() {
  return (
    <div className="App">
      <NavigationBar/>
      <Routes>
        <Route path = "/" element={<IntroPage/>}/>
        <Route path = "/corevalue" element = {<CoreValue/>}/>
        <Route path = "/overview" element = {<Overview/>}/>
        <Route path = "/ourteam" element = {<Team/>}/>
        <Route path = "/products" element = {<Products/>}/>
        <Route path = "/contactinfo" element={<ContactUs/>}/>
      </Routes>

      {/* WhatsApp floating button — high engagement for Indian users */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with Asava Pharmaceuticals on WhatsApp"
        style={{
          position: 'fixed',
          bottom: '28px',
          right: '28px',
          zIndex: 9999,
          backgroundColor: '#25D366',
          borderRadius: '50%',
          width: '58px',
          height: '58px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(37,211,102,0.45)',
          textDecoration: 'none',
          transition: 'transform 0.2s ease',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.12)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="#fff">
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.826.737 5.476 2.027 7.775L0 32l8.469-2.003A15.93 15.93 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 01-6.784-1.856l-.486-.289-5.026 1.188 1.224-4.895-.317-.502A13.267 13.267 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.878c-.398-.199-2.354-1.162-2.719-1.294-.365-.133-.63-.199-.896.199-.265.398-1.029 1.294-1.261 1.56-.232.265-.465.299-.863.1-.398-.199-1.681-.619-3.203-1.977-1.184-1.057-1.983-2.362-2.215-2.76-.232-.398-.025-.613.174-.811.179-.178.398-.465.597-.697.199-.232.265-.398.398-.664.133-.265.066-.498-.033-.697-.1-.199-.896-2.162-1.228-2.96-.323-.778-.651-.673-.896-.685l-.764-.013c-.265 0-.697.1-.1063.498-.365.398-1.394 1.362-1.394 3.321 0 1.959 1.427 3.852 1.626 4.117.199.265 2.808 4.287 6.803 6.013.951.41 1.693.655 2.272.839.954.304 1.823.261 2.509.158.766-.114 2.354-.962 2.686-1.891.332-.929.332-1.726.232-1.891-.099-.166-.365-.265-.763-.464z"/>
        </svg>
      </a>
    </div>
  );
}

export default App;
